import React from "react";
import ScheduleAwardSummaryTable from "./ScheduleAwardSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const ScheduleAwardSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={ScheduleAwardSummaryTable}
    loadingMessage="Loading scheduled award summary..."
  />
);

export default ScheduleAwardSummaryIndex;
